module.exports = __webpack_public_path__ + "img/F2M7.c1d84f70.jpg";